<template>
    <td-dialog
        :title="title"
        :before-close="protTestDialogClose"
        :visible.sync="dialogProtTestVisible"
        width="800px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
        v-dialogDrag
    >
        <el-form :model="formProtInfo" ref="formProtInfo" :rules="rules">
            <el-form-item :label="$t('common.ADAPTER_IP')" :label-width="formLabelWidth" prop="adapterIp">
                <el-autocomplete
                    class="inline-input"
                    v-model="formProtInfo.adapterIp"
                    :fetch-suggestions="querySearch"
                    :placeholder="$t('component.PLEASE_INPUT')"
                    @select="handleSelect"
                ></el-autocomplete>
            </el-form-item>
            <el-form-item :label="$t('common.ADAPTER_PORT')" :label-width="formLabelWidth" prop="adapterPort">
                <td-input-number v-model="formProtInfo.adapterPort" :min="1" :max="65535"></td-input-number>
            </el-form-item>
            <el-form-item :label="$t('common.PROT_EXECUTE')" :label-width="formLabelWidth" prop="executeTime">
                <td-input-number v-model="formProtInfo.executeTime" :min="1" :max="10"></td-input-number>
            </el-form-item>
            <el-form-item :label="$t('common.PROTCOL_MESSAGE')" :label-width="formLabelWidth" prop="ctlProtInfo">
                <td-input v-model="formProtInfo.ctlProtInfo" type="textarea" :rows="5" width="96%"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.UPLOAD_WAY')" :label-width="formLabelWidth" v-show="uploadWaySelect">
                <td-radio v-model="formProtInfo.uploadWay" :options="uploadWayRadio" @change="uplaodWayChange"></td-radio>
                <td-upload
                    :autoUpload="true"
                    ref="upload"
                    actionUrl="/devCtlProt/uploadFileEx"
                    :multiple="false"
                    :on-success="handResponse"
                    :on-error="handResponse"
                    message=""
                    :showFileList="true"
                    :limitSize="500"
                    v-show="uploadInfo"
                ></td-upload>
                <td-input v-model="formProtInfo.fileInfo" type="textarea" :rows="3" width="96%" v-show="uploadInfo1"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.DOWNLOAD_PATH')" :label-width="formLabelWidth" v-show="downloadpath">
                <td-input style="width:500px" v-model="formProtInfo.filePath" :placeholder="$t('message.MESSAGE_EXAMPLE')" :maxlength="500"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.LOG_MESSAGE')" :label-width="formLabelWidth" prop="logInfo">
                <td-input v-model="logInfo" type="textarea" :rows="4" width="96%" :readonly="true" placeholder=""></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="btnStartTest('formProtInfo')" :loading="loading">{{ $t('common.START_TEST') }} </td-button>
            <td-button @click="protTestDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from '../assets/api.js';
let self = '';
//订阅信息回调方法
function reciveCallback(message) {
    if (message.body) {
        self.logInfo = message.body + '\r\n--------日志信息记录分割----------\r\n' + self.logInfo;
    }
}
export default {
    props: ['title', 'dialogProtTestVisible', 'editItem'],
    created() {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        self = this;
        this.loading = false;
        if (this.editItem != null && this.editItem.ctlProtJson != null && this.editItem.ctlProtJson !== '') {
            this.formProtInfo.ctlProtInfo = this.formatJson(this.editItem.ctlProtJson);
            if (this.editItem.ctlMode == this.$common.deviceControlType.CTL_MODE_DOUBLE_STREAM && this.editItem.protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_UPLOAD) {
                this.uploadWaySelect = true;
                this.uploadInfo1 = true;
            }
            if (this.editItem.ctlMode == this.$common.deviceControlType.CTL_MODE_DOUBLE_STREAM && this.editItem.protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_DOWNLOAD) {
                this.downloadpath = true;
            }
        }
        this.formProtInfo.executeTime = 1;
        this.formProtInfo.uploadWay = this.$common.uploadWay.textWay;
        //mq请求路由标记
        this.routeKey = this.guid() + 'devCtrl';
        this.adapterInfo = this.$common.adapterInfo;
    },
    // 定义变量
    data() {
        return {
            formProtInfo: {
                adapterIp: '',
                adapterPort: 50058,
                executeTime: '',
                ctlProtInfo: '',
                uploadWay: '',
                fileInfo: '',
                filePath: ''
            },
            logInfo: '',
            consumerId: this.$common.devCtrlSubscribe.consumer,
            mqUseStatus: false,
            routeKey: '',
            uploadWaySelect: false,
            uploadInfo: false,
            uploadInfo1: false,
            downloadpath: false,
            loading: false,
            saveFileList: [],
            uploadWayRadio: [
                {
                    value: this.$common.uploadWay.textWay,
                    label: this.$t('common.UPLADD_STRING_WAY')
                },
                {
                    value: this.$common.uploadWay.fileWay,
                    label: this.$t('common.UPLADD_FILE_WAY')
                }
            ],
            adapterInfo: [],
            // 对表单进行数据验证
            rules: {
                adapterIp: [{ required: true, message: this.$t('error.ERROR_IP_FORMAT'), trigger: 'blur' }, { pattern: this.$regex.IP_RULE, message: this.$t('regex.IP_RULE') }],
                adapterPort: [{ required: true, message: this.$t('error.ERROR_INPUT_ADAPTER_PORT'), trigger: 'blur' }],
                ctlProtInfo: [{ required: true, message: this.$t('error.ERROR_INPUT_PROCTOL'), trigger: 'blur' }],
                executeTime: [{ type: 'number', required: true, message: this.$t('error.ERROR_ORDER_ILLEGAL'), trigger: 'blur' }]
            },
            formLabelWidth: '15%'
            // 对表单进行数据验证
        };
    },
    // 定义并实现方法体
    methods: {
        //实现输入框建议对象
        querySearch(queryString, cb) {
            let adapterInfo = this.adapterInfo;
            let results = queryString ? adapterInfo.filter(this.createFilter(queryString)) : adapterInfo;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return restaurant => {
                return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        //实现端口根据IP联动
        handleSelect(item) {
            this.formProtInfo.adapterPort = item.adapterPort;
        },
        //对象转json
        formatJson(json) {
            let reg = null;
            let formatted = '';
            let pad = 0;
            let PADDING = '    ';
            let options = {};
            options.newlineAfterColonIfBeforeBraceOrBracket = options.newlineAfterColonIfBeforeBraceOrBracket === true;
            options.spaceAfterColon = options.spaceAfterColon !== false;
            if (typeof json !== 'string') {
                json = JSON.stringify(json);
            } else {
                json = JSON.parse(json);
                json = JSON.stringify(json);
            }
            reg = /([{}])/g;
            json = json.replace(reg, '$1\r\n');
            reg = /([[\]])/g;
            json = json.replace(reg, '\r\n$1\r\n');
            reg = /(,)/g;
            json = json.replace(reg, '$1\r\n');
            reg = /(\r\n\r\n)/g;
            json = json.replace(reg, '\r\n');
            reg = /\r\n,/g;
            json = json.replace(reg, ',');
            if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
                reg = /:\r\n\{/g;
                json = json.replace(reg, ':{');
                reg = /:\r\n\[/g;
                json = json.replace(reg, ':[');
            }
            if (options.spaceAfterColon) {
                reg = /:/g;
                json = json.replace(reg, ':');
            }
            json.split('\r\n').forEach(function(node) {
                if (node === '') {
                    return;
                }
                let i = 0;
                let indent = 0;
                let padding = '';

                if (node.match(/\{$/) || node.match(/\[$/)) {
                    indent = 1;
                } else if (node.match(/\}/) || node.match(/\]/)) {
                    if (pad !== 0) {
                        pad -= 1;
                    }
                } else {
                    indent = 0;
                }

                for (i = 0; i < pad; i++) {
                    padding += PADDING;
                }

                formatted += padding + node + '\r\n';
                pad += indent;
            });
            return formatted;
        },
        //生成uuid
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },
        handResponse(response) {
            if (null === response) {
                this.$log.error('/test/handResponse', response);
                return;
            }
            if (response.statusCode !== this.$t('common.REQUEST_SUCCESS')) {
                this.$log.error('/test/handResponse1', response);
                return;
            }
            this.formProtInfo.filePath = response.content;
            this.saveFileList.push(response.content);
        },
        //参数校验
        checkParam() {
            let adapterCache = {
                value: this.formProtInfo.adapterIp,
                adapterPort: this.formProtInfo.adapterPort
            };
            if (this.$common.adapterInfo != null && this.$common.adapterInfo.length > 0) {
                let flag = false;
                for (let m = 0; m < this.$common.adapterInfo.length; m++) {
                    let ip = this.$common.adapterInfo[m].value;
                    if (ip === this.formProtInfo.adapterIp) {
                        flag = true;
                        this.$common.adapterInfo[m].adapterPort = this.formProtInfo.adapterPort;
                    }
                }
                if (!flag) {
                    this.$common.adapterInfo.push(adapterCache);
                }
            } else {
                this.$common.adapterInfo.push(adapterCache);
            }
            return true;
        },
        //开始调试
        btnStartTest(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.checkParam();
                    this.logInfo = this.$t('message.PLEASE_WAITING');
                    let param = {
                        adapterIp: this.formProtInfo.adapterIp,
                        adapterPort: this.formProtInfo.adapterPort,
                        protJson: this.formProtInfo.ctlProtInfo,
                        testTime: this.formProtInfo.executeTime,
                        ctrlMode: this.editItem.ctlMode,
                        protMode: this.editItem.protMode,
                        fileInfo: this.formProtInfo.fileInfo,
                        filePath: this.formProtInfo.filePath,
                        testFlag: 1,
                        routeKey: this.routeKey,
                        producer: this.$common.devCtrlSubscribe.producer,
                        token: sessionStorage.getItem('token')
                    };
                    let mqParam = {
                        routeKey: this.routeKey,
                        producer: this.$common.devCtrlSubscribe.producer
                    };
                    this.loading = true;
                    if (this.editItem.ctlMode === this.$common.deviceControlType.CTL_MODE_DOUBLE_STREAM) {
                        this.doubleStreamTest(mqParam, param);
                    } else {
                        this.simpleTest(param);
                    }
                }
            });
        },
        //双向流调试
        doubleStreamTest(mqParam, param) {
            Api.mqSubscribe(JSON.stringify(mqParam), response => {
                this.$log.info('devCtlProt/mqSubscribe', response);
                if (response === null || response.status !== this.$common.login.RESPONSE_STATUS || response.data === null || response.data.statusCode !== this.$t('common.REQUEST_SUCCESS')) {
                    this.logInfo = '';
                    this.loading = false;
                    this.logInfo = this.$t('error.ERROR_RESPONSE');
                    return;
                }
                if (!this.mqUseStatus) {
                    let returnInfo = this.$dataBusUtil.receiveMsgByRoutingKey(this.consumerId, this.routeKey, reciveCallback);
                    if (returnInfo != null && returnInfo.ret === 0) {
                        this.mqUseStatus = true;
                    } else {
                        this.logInfo = this.$t('error.ERROR_DEVCTRL_MQ_CONFIG');
                        this.loading = false;
                        this.$alert(this.$t('error.ERROR_DEVCTRL_MQ_CONFIG'));
                        return;
                    }
                }
                this.logInfo = '';
                Api.protTestMethod(JSON.stringify(param), response => {
                    this.$log.info('devCtlProt/protTestMethod', response);

                    this.loading = false;
                    if (response === null || response.status !== this.$common.login.RESPONSE_STATUS || response.data === null) {
                        this.logInfo = JSON.stringify(response);
                        if (this.mqUseStatus) {
                            this.$dataBusUtil.unSubscribeMsg(this.consumerId);
                        }
                        return;
                    }
                    if (response.data.statusCode !== this.$t('common.REQUEST_SUCCESS')) {
                        this.logInfo = JSON.stringify(response.data);
                        if (this.mqUseStatus) {
                            this.$dataBusUtil.unSubscribeMsg(this.consumerId);
                        }
                        return;
                    }
                    this.logInfo = JSON.stringify(response.data.content);
                });
            });
        },
        //简单控制调试
        simpleTest(param) {
            this.logInfo = '';
            Api.protTestMethod(JSON.stringify(param), response => {
                this.$log.info('devCtlProt/protTestMethod', response);
                this.loading = false;
                if (response === null || response.status !== this.$common.login.RESPONSE_STATUS || response.data === null) {
                    this.logInfo = this.$t('error.ERROR_RESPONSE');
                    if (this.mqUseStatus) {
                        this.$dataBusUtil.unSubscribeMsg(this.consumerId);
                    }
                    return;
                }
                if (response.data.statusCode !== this.$t('common.REQUEST_SUCCESS')) {
                    this.logInfo = JSON.stringify(response.data);
                    if (this.mqUseStatus) {
                        this.$dataBusUtil.unSubscribeMsg(this.consumerId);
                    }
                    return;
                }
                if (response.data.content !== null && response.data.content.length > 0) {
                    for (let i = 0; i < response.data.content.length; i++) {
                        this.logInfo = JSON.stringify(response.data.content[i]) + '\r\n--------日志信息记录分割----------\r\n' + this.logInfo;
                    }
                }
            });
        },
        //上传方式切换
        uplaodWayChange(value) {
            if (value == this.$common.uploadWay.textWay) {
                this.uploadInfo1 = true;
                this.uploadInfo = false;
                this.formProtInfo.filePath = '';
                this.$refs.upload.clearFiles();
            } else if (value == this.$common.uploadWay.fileWay) {
                this.formProtInfo.fileInfo = '';
                this.uploadInfo = true;
                this.uploadInfo1 = false;
            }
        },

        //删除文件
        deletFile() {
            Api.deleteFile(this.saveFileList, response => {
                this.$log.info('devCtlProt/deletFile', response);
            });
        },
        // 关闭窗口之前需要调用的方法
        protTestDialogClose() {
            if (this.mqUseStatus) {
                this.$dataBusUtil.unSubscribeMsg(this.consumerId);
            }
            if (this.saveFileList.length !== 0) {
                this.deletFile();
            }
            this.$emit('protTestDialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
